import { render, staticRenderFns } from "./AgencyInfoCard.vue?vue&type=template&id=2528e924&scoped=true"
import script from "./AgencyInfoCard.vue?vue&type=script&lang=js"
export * from "./AgencyInfoCard.vue?vue&type=script&lang=js"
import style0 from "./AgencyInfoCard.vue?vue&type=style&index=0&id=2528e924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528e924",
  null
  
)

export default component.exports